import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "@app/providers/ThemeProvider";
import { Navbar } from "@components/index";
import { ErrorBoundary } from "@shared/components/ui/ErrorBoundary";
import { LoadingBoundary } from "@shared/components/ui/LoadingBoundary";
import { NotFound } from "@shared/components/ui/NotFound";
import { ROUTES } from "./app/config/routes";
import Footer from "@shared/components/layout/Footer";
import { lazy } from "react";
import WhatsAppButton from "@shared/components/ui/WhatsAppButton";
import FloatingUserButton from "@shared/components/FloatingUserButton";


// Lazy load de todas las páginas
const HomePage = lazy(() => import("@features/home/pages/HomePage"));
const DesarrolloPage = lazy(() => import("@features/desarrollo/pages/DesarrolloPage"));
const InfraestructuraPage = lazy(() => import("@features/infraestructura/pages/InfraestructuraPage"));
const ServiciosCloudPage = lazy(() => import("@features/servicios-cloud/pages/ServiciosCloudPage"));
const ServiciosTIPage = lazy(() => import("@features/servicios-ti/pages/ServiciosTIPage"));
const ProyectosPage = lazy(() => import("@features/proyectos/pages/ProyectosPage"));
const ServidoresPage = lazy(() => import("@features/servidoresdedicados/pages/servidoresPage"));
const QuienesSomosPage = lazy(() => import("@features/home/pages/QuienesSomosPage"));
const PoliticasPrivacidadPage = lazy(() => import("@features/home/pages/PoliticasPrivacidadPage"));
const ServidoresVPSPage = lazy(() => import("@features/servidores-vps/pages/ServidoresVPSPage"));
const ServidoresNubePage = lazy(() => import("@features/servidores-nube/pages/ServidoresNubePage"));
const Office365Page = lazy(() => import("./features/servicios-cloud/pages/Office365Page"));
const AcronisPage = lazy(() => import("./features/servicios-ti/pages/AcronisPage"));
const KasperskyPage = lazy(() => import("./features/servicios-ti/pages/KasperskyPage"));
const ContactPage = lazy(() => import("@features/contacto/page"));  

// Lazy load de páginas de proyectos individuales
const HemogroupPage = lazy(() => import("@features/proyectos/pages/HemogroupPage"));
const VlipsPage = lazy(() => import("@features/proyectos/pages/VlipsPage"));
const TerminalSurPage = lazy(() => import("@features/proyectos/pages/TerminalSurPage"));
const AdminSoportePage = lazy(() => import("@features/proyectos/pages/AdminSoportePage"));
const AdminSoporteCatalogoPage = lazy(() => import("@features/proyectos/pages/AdminSoporteCatalogoPage"));
const OrdenaFacilPage = lazy(() => import("@features/proyectos/pages/OrdenaFacilPage"));
const OrdenaFacilCatalogoPage = lazy(() => import("@features/proyectos/pages/OrdenaFacilCatalogoPage"));
const MiTurnoPage = lazy(() => import("@features/proyectos/pages/MiTurnoPage"));
const MiTurnoCatalogoPage = lazy(() => import("@features/proyectos/pages/MiTurnoCatalogoPage"));
const FacturacionElectronicaCatalogoPage = lazy(() => import("@features/proyectos/pages/FacturacionElectronicaCatalogoPage"));
const ServiciosCatalogoPage = lazy(() => import("@features/proyectos/pages/ServiciosCatalogoPage"));

const AppContent = () => {
  const location = useLocation();
  return (
    <div className="app">
      <Navbar />
      <main className="min-h-screen" role="main">
        <LoadingBoundary>
          <Routes>
            <Route path={ROUTES.HOME} element={<HomePage />} />
            <Route path={ROUTES.DESARROLLO} element={<DesarrolloPage />} />
            <Route path={ROUTES.INFRAESTRUCTURA} element={<InfraestructuraPage />} />
            <Route path={ROUTES.SERVICIOS_CLOUD} element={<ServiciosCloudPage />} />
            <Route path={ROUTES.SERVICIOS_TI} element={<ServiciosTIPage />} />
            <Route path={ROUTES.PROYECTOS} element={<ProyectosPage />} />
            <Route path={ROUTES.SERVIDORES_DEDICADOS} element={<ServidoresPage />} />
            <Route path={ROUTES.CONTACTO} element={<ContactPage />} />
            <Route path={ROUTES.QUIENES_SOMOS} element={<QuienesSomosPage />} />
            <Route path={ROUTES.POLITICAS_PRIVACIDAD} element={<PoliticasPrivacidadPage />} />
            <Route path={ROUTES.VPS_COTIZAR} element={<ServidoresVPSPage />} />
            <Route path={ROUTES.NUBE_COTIZAR} element={<ServidoresNubePage />} />
            <Route path={ROUTES.OFFICE365_COTIZAR} element={<Office365Page />} />
            <Route path={ROUTES.ACRONIS_COTIZAR} element={<AcronisPage />} />
            <Route path={ROUTES.KASPERSKY} element={<KasperskyPage />} />
            
            {/* Rutas de proyectos individuales */}
            <Route path={ROUTES.PROYECTO_HEMOGROUP} element={<HemogroupPage />} />
            <Route path={ROUTES.PROYECTO_VLIPS} element={<VlipsPage />} />
            <Route path={ROUTES.PROYECTO_TERMINAL_SUR} element={<TerminalSurPage />} />
            <Route path={ROUTES.PROYECTO_ADMIN_SOPORTE} element={<AdminSoportePage />} />
            <Route path={ROUTES.PROYECTO_ADMIN_SOPORTE_CATALOGO} element={<AdminSoporteCatalogoPage />} />
            <Route path={ROUTES.PROYECTO_ORDENA_FACIL} element={<OrdenaFacilPage />} />
            <Route path={ROUTES.PROYECTO_ORDENA_FACIL_CATALOGO} element={<OrdenaFacilCatalogoPage />} />
            <Route path={ROUTES.PROYECTO_MI_TURNO} element={<MiTurnoPage />} />
            <Route path={ROUTES.PROYECTO_MI_TURNO_CATALOGO} element={<MiTurnoCatalogoPage />} />
            <Route path={ROUTES.PROYECTO_FACTURACION_CATALOGO} element={<FacturacionElectronicaCatalogoPage />} />
            <Route path={ROUTES.PROYECTO_SERVICIOS_CATALOGO} element={<ServiciosCatalogoPage />} />
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </LoadingBoundary>
      </main>
      <Footer />
      {location.pathname === "/" && <FloatingUserButton />}
      <WhatsAppButton />
    </div>
  );
};

const App = () => {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <Router>
          <AppContent />
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
